export const REQUIRED_CALCULATIONS = "2fdfe764-de26-45b6-be7d-8ef1fd077358";
export const BORROWER_LIST_OF_DOCUMENTS = "8d6a8cc4-ac41-11eb-a6e5-00ffdc22d1cc";
export const GUARANTOR_LIST_OF_DOCUMENTS = "27d8564c-ac43-11eb-a6e5-00ffdc22d1cc";
export const CASHMANAGEMENT_LIST_OF_DOCUMENTS = "28007bf8-b727-11eb-8430-00ffdc22d1cc";
export const SYSTEM_ACTIONS = "786f5fbd-ec34-4b17-972a-2d344f5e819d";
export const DOC_MODAL = "DOC_MODAL";
export const SIMPLE_INFO_MODAL = "SIMPLE_INFO_MODAL";

export const SYSTEM_ACTION = {
  BALANCE_SHEET: {
    name: "Attach Balance Sheet",
    id: "ed1ed109-17c9-4133-a161-0ed6b7058652"
  },
  TRAILING_CASHFLOWS: {
    name: "Attach 12M Trailing Cashflows",
    id: "5d91ba63-5244-41f5-9e77-2971083b4439"
  },
  BUDGETED_CASHFLOWS: {
    name: "Attach 12 Budgeted Cashflows",
    id: "5b81a60d-60f2-4632-a0a4-7e3700036bb2"
  },
  DSCR_CALCULATION: {
    name: "Create DSCR Calculation",
    id: "d31c2850-64e7-4ce4-acba-561c62407370"
  },
  DEBT_YIELD_CALCULATION: {
    name: "Create Debt Yield Calculation",
    id: "d8410b99-ded6-4c5f-89ca-84419b0ec8de"
  },
  ATTACH_BUDGETED_CASHFLOWS_FOR_PRIOR_TO_REPORTING: {
    name: "Attach Budgeted Cashflows for Prior To Reporting",
    id: "b7c9f223-64b7-4089-8c77-6cd5753ad7a9"
  },
  ATTACH_RENT_ROLL: {
    name: "Attach Rent Roll",
    id: "0b9fae49-c6e2-4d46-9c71-0b523161ad9e"
  }
};

export const SYSTEM_ACTION_IDS = {
  "ed1ed109-17c9-4133-a161-0ed6b7058652": "Attach Balance Sheet",
  "5d91ba63-5244-41f5-9e77-2971083b4439": "Attach 12M Trailing Cashflows",
  "5b81a60d-60f2-4632-a0a4-7e3700036bb2": "Attach 12 Budgeted Cashflows",
  "d31c2850-64e7-4ce4-acba-561c62407370": "Create DSCR Calculation",
  "d8410b99-ded6-4c5f-89ca-84419b0ec8de": "Create Debt Yield Calculation",
  "b7c9f223-64b7-4089-8c77-6cd5753ad7a9": "Attach Budgeted Cashflows for Prior To Reporting",
  "0b9fae49-c6e2-4d46-9c71-0b523161ad9e": "Attach Rent Roll"
};
